import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  selectstyle: {
    backgroundColor: '#fff',
  },
  selectLable: {
    lineHeight: '2px',
    fontSize: '11px',
  },
}));

export const useStylesDialogServiceCall = makeStyles((theme) => ({
  dialogMain: {
    '& .MuiDialog-paper': {
      borderRadius: '10px',
      overflowY: 'inherit',
    },
    '& .MuiDialogContent-root': {
      overflowY: 'auto',
      '&::scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-moz-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-track': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar': {
        width: '0',
        minWidth: '0',
      },
      '&::-webkit-scrollbar-thumb': {
        width: '0',
        minWidth: '0',
      },
      '&.noneOverFlow': {
        overflowY: 'inherit',
      },
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'flex-start',
      display: 'flex',
      flexDirection: 'row-reverse',
      padding: '20px',
      gap: '15px',
    },
    '& .MuiDialog-container': {
      width: '100vw',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  },
  title: {
    margin: 0,
    padding: '20px',
    borderBottom: '1px solid #E2E5E9',

    '& h2': {
      fontSize: 16,
      color: '#0C0E10',
    },
  },
  dialog: {
    textAlign: 'left',
    direction: 'ltr',
    padding: theme.spacing(2),
    lineHeight: 2,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));
export const useStylesDateTimePickerDialog = makeStyles((theme) => ({
  titleDatePicker: {
    marginBottom: theme.spacing(1),
    fontSize: '13px',
  },
  boxDate: {
    marginRight: theme.spacing(5),
  },
  boxDteTo: {
    marginLeft: theme.spacing(5),
  },
  filterButton: {
    color: theme.palette.warning.main,
    borderColor: theme.palette.warning.main,
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2),
    },
  },
  boxButton: {
    textAlign: 'right !important',
    marginTop: theme.spacing(4),
    marginRight: theme.spacing(2),
  },
}));
